import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { AssistanceNavBar } from "../../components/Assistances/AssistanceNavBar";
import DigitalSignature from "../../components/Assistances/DigitalSignature";
import ViewSignature from "../../components/Assistances/ViewSignature";
import ButtonComponent from "../../components/ButtonComponent";
import ChangeStatusComponent from "../../components/ChangeStatusComponent";
import { generatePDF } from "../../components/GeneratePDF";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import { useMobile } from "../../components/Layout/UseResponsive";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";
import Toast from "../../helpers/Toast";
import { AssistanceDTO } from "../../models/Assistance/AssistanceDTO";
import { DigitalSignatureDTO } from "../../models/Assistance/DigitalSignatureDTO";
import { AssistanceService } from "../../services/AssistanceService";
import { ExecutionButtons } from "./ExecutionButtons";

export function AssistanceDetails() {
    const intl = useIntl();
    const isMobile = useMobile(606);
    const { availableModules } = useAvailableModulesContext();
    const { assistanceId } = useParams<{ assistanceId: string }>();
    const [isLoadingAssistance, setIsLoadingAssistance] = useState<boolean>(false);
    const assistanceService = new AssistanceService();
    const [assistanceNotFound, setAssistanceNotFound] = useState<boolean>(false);
    const [assistance, setAssistance] = useState<AssistanceDTO>({} as AssistanceDTO);
    const [reloadExecutions, setReloadExecutions] = useState<boolean>(false);
    const [ChangeStatusIsOpen, setChangeStatusIsOpen] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);
    const [isSignatureOpen, setIsSignatureOpen] = useState(false);
    const [isViewSignatureOpen, setIsViewSignatureOpen] = useState<boolean>(false);
    // Assinatura
    const [isActivateDigitalSignature, setIsActivateDigitalSignature] = useState<boolean>(false);
    const [isActiveErpSupportModule, setIsActiveErpSupportModule] = useState<boolean>(false);
    // Execuções / Tempos
    const [fetchExecutionsData, setFetchExecutionsData] = useState<boolean>(false);

    const onFetchExecutionsData = () => {
        setFetchExecutionsData(!fetchExecutionsData);
    };

    const getAssistance = async () => {
        setIsLoadingAssistance(true);
        var response = await assistanceService.GetById(parseInt(assistanceId ?? "0"));
        setIsLoadingAssistance(false);

        if (response.success !== true || response.obj == null) {
            setAssistanceNotFound(true);
            Toast.Show("error", response.message);
            return;
        }

        setAssistance(response.obj);
    };

    const reloadExecutionsFunction = () => {
        setReloadExecutions(!reloadExecutions);
    };

    const handleSignatureDialog = () => {
        setIsSignatureOpen(!isSignatureOpen);
    };

    const handleSignatureCancel = () => {
        setIsSignatureOpen(false);
    };

    const handleSignatureSave = async (signatureData: DigitalSignatureDTO) => {
        // Chama a API com a assinatura
        const response = await assistanceService.SubmitDigitalSignature(Number(assistance.id), signatureData);
        if (response === null || !response.success) {
            Toast.Show("error", response.message);
        }
        setReload(!reload);

        Toast.Show("success", intl.formatMessage({ id: "AssistanceEdit.SignSuccess" }));
    }

    const handleSignaturePopUp = () => {
        setIsViewSignatureOpen(!isViewSignatureOpen);
    };

    const handleCloseSignaturePopUp = () => {
        setIsViewSignatureOpen(false);
    };

    const handleClearSignature = async () => {
        const response = await assistanceService.ClearDigitalSignature(Number(assistance.id));
        if (response === null || !response.success) {
            Toast.Show("error", response.message || "Erro ao limpar a assinatura");
        } else {
            Toast.Show("success", intl.formatMessage({ id: "AssistanceEdit.SignatureCleared" }) || "Assinatura limpa com sucesso");
            setIsViewSignatureOpen(false);
            setReload(!reload);
        }
    };

    //obter valor setting (módulo assinatura)
    useEffect(() => {
        if (availableModules.includes("IsActiveDigitalSignature")) {
            setIsActivateDigitalSignature(true);
        }
        if (availableModules.includes("IsActiveErpSupportModule")) {
            setIsActiveErpSupportModule(true);
        }
    }, [availableModules]);

    useEffect(() => {
        getAssistance();
    }, [reload]);

    return (
        <Layout>
            <ChangeStatusComponent
                close={() => setChangeStatusIsOpen(false)}
                AssistanceId={assistance.id}
                IsOpen={ChangeStatusIsOpen}
                onAdded={() => setReload(!reload)}
            />

            {!isMobile ? (
                <div className="pageContainer">
                    <Row className="pageHeader" style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                        <Col xl={4} lg={4} md={12} sm={12} xs={12} style={{ display: "flex", margin: "0px" }}>
                            <PageTitle
                                title={
                                    isActiveErpSupportModule
                                        ? `Assistência ${assistance.supportNumber}`
                                        : `Assistência ${assistance.erpDocType ?? ""} ${assistance.erpSerie ?? ""} ${assistance.erpNumDoc ?? ""} ${assistance.assistanceType === "Reparação"
                                            ? "- Reparação"
                                            : assistance.assistanceType === "Fabricação"
                                                ? "- Fabricação"
                                                : ""
                                        }`
                                }
                                allowGoBack={true}
                            />
                        </Col>
                        <Col
                            xl={8}
                            lg={8}
                            md={12}
                            sm={12}
                            xs={12}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >

                            {isActivateDigitalSignature && (
                                <>
                                    {assistance.digitalSignature === null ? (
                                        <>
                                            {assistance.userCanEdit && (
                                                <>
                                                    <ButtonComponent
                                                        style={{
                                                            marginRight: "1%",
                                                            minWidth: "70px",
                                                        }}
                                                        text={intl.formatMessage({ id: "AssistanceEdit.Signature" })}
                                                        onClick={() => handleSignatureDialog()}
                                                    />
                                                    {isSignatureOpen && (
                                                        <DigitalSignature
                                                            onCancel={handleSignatureCancel}
                                                            onSave={(dataUrl: string) => {
                                                                const signatureData: DigitalSignatureDTO = {
                                                                    signature: dataUrl,
                                                                };
                                                                handleSignatureSave(signatureData);
                                                            }}
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <ButtonComponent
                                                style={{
                                                    marginRight: "1%",
                                                    minWidth: "70px",
                                                }}
                                                text={intl.formatMessage({ id: "AssistanceEdit.SeeSignature" })}
                                                onClick={() => handleSignaturePopUp()}
                                            />
                                            {isViewSignatureOpen && (
                                                <ViewSignature
                                                    signature={assistance.digitalSignature ?? ""}
                                                    onClose={handleCloseSignaturePopUp}
                                                    onClear={assistance.userCanEdit ? handleClearSignature : undefined}
                                                    isSaved={true}
                                                />
                                            )}
                                        </>
                                    )}
                                </>
                            )}

                            <ButtonComponent
                                style={{
                                    marginRight: "2%", minWidth: "139px"
                                }}
                                text={intl.formatMessage({ id: "AssistanceEdit.Download" })}
                                onClick={() => generatePDF(assistance.erpNumDoc, assistance.erpDocType, assistance.erpSerie)}
                            />

                            <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                Técnico: {assistance.technician === "" ? "Não atribuído" : assistance.technician}{" "}
                            </span>

                            <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                Estado: <span style={{ textTransform: "uppercase" }}>{assistance?.status}</span>
                            </span>
                            {assistance.userCanChangeStatus && (
                                <ButtonComponent onClick={() => setChangeStatusIsOpen(true)}
                                    text={intl.formatMessage({ id: "AssistanceDetails.UpdateStatus" })} />
                            )}
                        </Col>
                    </Row>

                    <div className="pageBody">
                        {/* Se o pedido para obter a assistencia não retornou nada */}
                        {assistanceNotFound === true && (
                            <div>
                                <span className="error">A assistência selecionada não foi encontrada.</span>
                            </div>
                        )}
                        {/* Navbar da assistência */}
                        <AssistanceNavBar
                            mode={"workshop"}
                            setAssistance={setAssistance}
                            assistance={assistance}
                            isLoadingAssistance={isLoadingAssistance}
                            getAssistance={getAssistance}
                            reloadExecutions={reloadExecutions}
                            childrenColumnSize={6}
                            onFetchExecutionsData={onFetchExecutionsData}
                        />

                        {/* Botões para começar e completar execução */}
                        <ExecutionButtons
                            assistance={assistance}
                            setAssistance={setAssistance}
                            reloadExecutions={reloadExecutionsFunction}
                            onFetchExecutionsData={onFetchExecutionsData}
                        />
                    </div>
                </div>

            ) : (

                <div className="pageContainer">
                    <Row className="pageHeader">
                        <Row>
                            <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                                <PageTitle
                                    title={
                                        isActiveErpSupportModule
                                            ? `Assistência ${assistance.supportNumber}`
                                            : `Assistência ${assistance.erpDocType ?? ""} ${assistance.erpSerie ?? ""} ${assistance.erpNumDoc ?? ""} ${assistance.assistanceType === "Reparação"
                                                ? "- Reparação"
                                                : assistance.assistanceType === "Fabricação"
                                                    ? "- Fabricação"
                                                    : ""
                                            }`
                                    }
                                    allowGoBack={true}
                                />
                            </Col>
                        </Row>

                        <Row style={{ marginBottom: "10px", marginTop: "10px" }}>
                            {isActivateDigitalSignature && (
                                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                    {assistance.digitalSignature === null ? (
                                        <>
                                            {assistance.userCanEdit && (
                                                <>
                                                    <ButtonComponent
                                                        style={{
                                                            marginRight: "1%",
                                                            minWidth: "70px",
                                                        }}
                                                        text={intl.formatMessage({ id: "AssistanceEdit.Signature" })}
                                                        onClick={() => handleSignatureDialog()}
                                                    />
                                                    {isSignatureOpen && (
                                                        <DigitalSignature
                                                            onCancel={handleSignatureCancel}
                                                            onSave={(dataUrl: string) => {
                                                                const signatureData: DigitalSignatureDTO = {
                                                                    signature: dataUrl,
                                                                };
                                                                handleSignatureSave(signatureData);
                                                            }}
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <ButtonComponent
                                                style={{
                                                    marginRight: "1%",
                                                    minWidth: "70px",
                                                }}
                                                text={intl.formatMessage({ id: "AssistanceEdit.SeeSignature" })}
                                                onClick={() => handleSignaturePopUp()}
                                            />
                                            {isViewSignatureOpen && (
                                                <ViewSignature
                                                    signature={assistance.digitalSignature ?? ""}
                                                    onClose={handleCloseSignaturePopUp}
                                                    onClear={assistance.userCanEdit ? handleClearSignature : undefined}
                                                    isSaved={true}
                                                />
                                            )}
                                        </>
                                    )}
                                </Col>
                            )}
                        </Row>

                        <Row style={{ marginBottom: "10px" }}>
                            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                <ButtonComponent
                                    style={{
                                        marginRight: "2%",
                                        minWidth: "139px",
                                    }}
                                    text={intl.formatMessage({ id: "AssistanceEdit.Download" })}
                                    onClick={() => generatePDF(assistance.erpNumDoc, assistance.erpDocType, assistance.erpSerie)}
                                />
                            </Col>
                        </Row>

                        <Row style={{ marginBottom: "10px" }}>
                            <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                                <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                    Técnico: {assistance.technician === "" ? "Não atribuído" : assistance.technician}{" "}
                                </span>
                            </Col>
                        </Row>

                        <Row style={{ marginBottom: "10px" }}>
                            <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                                <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                    Estado: <span style={{ textTransform: "uppercase" }}>{assistance?.status}</span>
                                </span>
                            </Col>
                            {assistance.userCanChangeStatus && (
                                <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                                    <ButtonComponent onClick={() => setChangeStatusIsOpen(true)} style={{ minWidth: "104px" }}
                                        text={intl.formatMessage({ id: "AssistanceEdit.UpdateStatus" })}
                                    />
                                </Col>
                            )}
                        </Row>
                    </Row>

                    <div className="pageBody">
                        {/* Se o pedido para obter a assistencia não retornou nada */}
                        {assistanceNotFound === true && (
                            <div>
                                <span className="error">A assistência selecionada não foi encontrada.</span>
                            </div>
                        )}
                        {/* Navbar da assistência */}
                        <AssistanceNavBar
                            mode={"workshop"}
                            setAssistance={setAssistance}
                            assistance={assistance}
                            isLoadingAssistance={isLoadingAssistance}
                            getAssistance={getAssistance}
                            reloadExecutions={reloadExecutions}
                            childrenColumnSize={6}
                            onFetchExecutionsData={onFetchExecutionsData}
                        />

                        {/* Botões para começar e completar execução */}
                        <ExecutionButtons
                            assistance={assistance}
                            setAssistance={setAssistance}
                            reloadExecutions={reloadExecutionsFunction}
                            onFetchExecutionsData={onFetchExecutionsData}
                        />
                    </div>
                </div>
            )}
        </Layout>
    );
}
